export default {
  default: {
    error: `Sorry, an error occurred, please try again`,
    success: ``,
  },
  getCode: {
    404: `Looks like the code you entered is invalid. Please check the code and try again`,
  },
};
